// Marke – die EINE Stelle für Produktname, Logo und Akzentfarbe des Produkts.
// Produktname „Ordaneo“ (seit 20.10.2026, früher Arbeitstitel „Merxo“, docs/ENTSCHEIDUNGEN.md §5). Umbenennen heißt,
// diese Datei, web/public/ordaneo-mark.svg, web/public/favicon.svg und die Wortmarke in web/ui/Logo.tsx zu ändern.
// Technische Kennungen (storagePrefix, MERXO_*, X-Merxo-*, MerxoApp/…) bleiben bewusst beim alten Namen.
// Mandanten-Branding (Logo, Hausfarbe) überschreibt zur Laufzeit per CSS-Variablen, nicht hier.

export type AccentStyle = 'mono' | 'deep' | 'bright'

export const brand = {
  /** Produktname in Fließtext, Titelzeile, E-Mails */
  name: 'Ordaneo',
  /** Wortmarke (klein geschrieben) neben der Bildmarke */
  wordmark: 'ordaneo',
  claim: 'Warenwirtschaft für Lager, Filialen und Handel',
  logo: {
    /** Bildmarke, ausgeliefert aus web/public */
    markUrl: '/ordaneo-mark.svg',
    /**
     * Farbe der „Einheit“ (des Quadrats) ohne Hausfarbe, Entscheidung Christoph 20.10.2026: Orange auf der
     * Graphit-Kachel (5,4 : 1). Entspricht --color-logo-unit im hellen Theme (web/styles/tokens.css).
     */
    unit: '#e8650e',
    /**
     * Tieferes Orange derselben Farbfamilie für helle Kacheln und hellen Grund (dunkles Theme, Zeichen ohne Kachel im
     * hellen Theme): 4,0 : 1 auf #f3f4f6 – das helle Orange käme dort nur auf 3,0 : 1.
     */
    unitOnLight: '#c9530a',
  },
  /** Akzent des Produkts: Graphit, ohne Buntheit. Entspricht den Standardwerten in web/styles/tokens.css. */
  accent: {
    hex: '#15171b',
    style: 'mono' as AccentStyle,
  },
  /** Browser-Leiste / PWA-Kachel je Theme (= --color-canvas) */
  themeColor: { light: '#f9fafb', dark: '#090a0d' },
  /** Präfix für localStorage-Schlüssel, Cookies und Service-Worker-Caches – bleibt 'merxo' (Bestand: Sitzungen, Geräte, Caches) */
  storagePrefix: 'merxo',
} as const

export type Brand = typeof brand

/** Seitentitel: „Bestand · Ordaneo“ */
export const pageTitle = (title?: string): string => (title ? `${title} · ${brand.name}` : brand.name)
